export default "__VITE_ASSET__CezdiomU__"